import { render, staticRenderFns } from "./SendToAbattoir.vue?vue&type=template&id=2b85d9c8&"
import script from "./SendToAbattoir.vue?vue&type=script&lang=js&"
export * from "./SendToAbattoir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports